import React, { useEffect, useState } from 'react';
import Button from '@salesforce/design-system-react/module/components/button';
import Dropdown from '@salesforce/design-system-react/module/components/menu-dropdown';
import DropdownTrigger from '@salesforce/design-system-react/module/components/menu-dropdown/button-trigger';
import DataTable from '@salesforce/design-system-react/module/components/data-table';
import DataTableColumn from '@salesforce/design-system-react/module/components/data-table/column';
import DataTableCell from '@salesforce/design-system-react/module/components/data-table/cell';
import PageHeader from '@salesforce/design-system-react/module/components/page-header';
import { actions as Actions } from '../../../components/Accounts/actions';
import { controls } from '../../../components/Accounts/controls';
import { useDispatch, useSelector } from 'react-redux';
import { getAccounts, accountsSelector } from '../../../store/accounts/slice';
import { Link } from 'react-router-dom';

const CustomDataTableCell = ({ children, ...props }) => {
  const { item } = props;
  return (
    <DataTableCell title={children} {...props}>
      <Link to={`${item.id}`}>
        {children}
      </Link>
    </DataTableCell>
  );
};

// need to figure what what this does
CustomDataTableCell.displayName = DataTableCell.displayName;

const CustomDataTableAccount = ({ children, ...props }) => {
  return (
    <DataTableCell title={children} {...props}>
      <p>Fantom</p>
    </DataTableCell>
  );
};
CustomDataTableAccount.displayName = DataTableCell.displayName;

const CustomDataTableQuantity = ({ children, ...props }) => {
  return (
    <DataTableCell title={children} {...props}>
      <p>1,200,000.34</p>
    </DataTableCell>
  );
};
CustomDataTableQuantity.displayName = DataTableCell.displayName;

const CustomDataTableValue = ({ children, ...props }) => {
  return (
    <DataTableCell title={children} {...props}>
      <p>$1000,000.00</p>
    </DataTableCell>
  );
};
CustomDataTableValue.displayName = DataTableCell.displayName;

const CustomDataTableProtocol = ({ children, ...props }) => {
  return (
    <DataTableCell title={children} {...props}>
      <span className="slds-m-right_xx-small">
        <img src="/assets/icons/menus/transactions.svg" alt=""></img>
      </span>
      Tomb
      {children}
    </DataTableCell>
  );
};
CustomDataTableProtocol.displayName = DataTableCell.displayName;

const CustomDataTableChain = ({ children, ...props }) => {
  return (
    <DataTableCell title={children} {...props}>
      <span className="slds-m-right_xx-small">
        <img src="/assets/icons/chain/fantom.svg" alt=""></img>
      </span>
      {children}
    </DataTableCell>
  );
};
CustomDataTableChain.displayName = DataTableCell.displayName;

const CustomDataTableNotes = ({ children, ...props }) => {
  const [editedValue, setEditedValue] = useState(children);
  return (
    <DataTableCell title={children} {...props}>
      <input
        type="text"
        value={editedValue}
        onChange={(e) => setEditedValue(e.target.value)}
        className="editable-cell-input"
      />
    </DataTableCell>
  );
};
CustomDataTableNotes.displayName = DataTableCell.displayName;



const CustomDataTableDate = ({ children, ...props }) => {
  return (
    <DataTableCell title={children} {...props}>
      <p>10/16/2020 23:43:23</p>
    </DataTableCell>
  );
};
CustomDataTableDate.displayName = DataTableCell.displayName;

const Transaction = () => {
  const dispatch = useDispatch();
  const { accounts, loading } = useSelector(accountsSelector);
  const [sortColumn, setSortColumn] = useState('opportunityName');
  const [sortColumnDirection, setSortColumnDirection] = useState({
    opportunityName: 'asc',
  });

  const [items, setItems] = useState([]);

  const [accountsDropDown, setAccountsDropDown] = useState('0');
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [isPageLoading, setIsPageLoading] = useState(false);

  useEffect(() => {
    dispatch(getAccounts());
  }, [dispatch]);

  useEffect(() => {
    if (accounts.length > 0) setItems(accounts);
  }, [accounts]);

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  const handleSort = (sortColumn, ...rest) => {
    const sortProperty = sortColumn.property;

    const { sortDirection } = sortColumn;

    setSortColumn(sortProperty);
    setSortColumnDirection({
      [sortProperty]: sortDirection,
    });

    // sorting will actually be handled from api
    // so dispatch sort action in useEffect
    // dispatch(sortAccounte({sortDirection, sortProperty}))
    // and the update the state with sorted accounts lists this will be done by above useEffect
  };



  const handleLoadMore = () => {
    if (!isLoading && !isPageLoading) {
      setTimeout(() => {
        const newitems = items.slice(0, 10).map((item) => {
          const copy = { ...item };
          copy.id += page.toString();
          return copy;
        });

        setPage(page + 1);
        setItems(items.concat(newitems));
        setHasMore(page !== 5);
        setIsPageLoading(false);
      }, 1000);
    }

    if (!isLoading) {
      setIsPageLoading(true);
    }
  };

  return (
    <div className="pageContent">
      <PageHeader
        icon={<img src="/assets/icons/menus/transactions.svg" alt=""></img>}
        info="10 items • Recently updated"
        joined
        label="Assets Monitored"
        title={
          <h1 className="slds-page-header__title slds-p-right_x-small">
            <Dropdown id="page-header-dropdown-object-home-header">
              <DropdownTrigger>
                <Button
                  className="slds-button_reset slds-type-focus"
                  iconCategory="utility"
                  iconName="down"
                  iconPosition="right"
                  label="All Assets"
                  responsive
                  variant="base"
                />
              </DropdownTrigger>
            </Dropdown>
          </h1>
        }
        onRenderActions={() =>
          Actions({
            onDropDownSelect: (value) => {
              setAccountsDropDown(value);
            },
            value: accountsDropDown,
            options: [
              { label: 'Choose', value: '0' },
              { label: 'Menu Item One', value: 'A0' },
              { label: 'Menu Item Two', value: 'B0' },
              { label: 'Menu Item Three', value: 'C0' },
              { type: 'divider' },
              { label: 'Menu Item Four', value: 'D0' },
            ],
          })
        }
        onRenderControls={controls}
        truncate
        variant="object-home"
      />

      <div>
        <DataTable
          assistiveText={{
            actionsHeader: 'actions',
            columnSort: 'sort this column',
            columnSortedAscending: 'asc',
            columnSortedDescending: 'desc',
            selectAllRows: 'Select all rows',
            selectRow: 'Select this row',
          }}
          fixedHeader
          fixedLayout
          items={items}
          id="DataTableExample-FixedHeaders"
          onSort={handleSort}
          hasMore={hasMore}
          onLoadMore={handleLoadMore}
          noRowHover
        >
          <DataTableColumn label="Assets" property="assets">
            <CustomDataTableAccount />
          </DataTableColumn>
          <DataTableColumn sortable isDefaultSortDescending label="Quantity" property="quantity ">
            <CustomDataTableQuantity />
          </DataTableColumn>
          <DataTableColumn sortable isDefaultSortDescending label="Value" property="value ">
            <CustomDataTableValue />
          </DataTableColumn>
          <DataTableColumn label="Protocol" property="protocol">
            <CustomDataTableProtocol />
          </DataTableColumn>
          <DataTableColumn label="Notes" property="notes">
            <CustomDataTableNotes />
          </DataTableColumn>
          <DataTableColumn label="Transaction Date">
            <CustomDataTableDate />
          </DataTableColumn>
        </DataTable>
      </div>
    </div>
  );
};

export default Transaction;
